import { useState } from 'react';
import type { InquiryFormData } from '@/types';
import { inquiriesApi } from '@/services/api';

export function useInquiry() {
  const [isPending, setIsPending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitInquiry = async (data: InquiryFormData) => {
    setIsPending(true);
    setError(null);
    try {
      await inquiriesApi.create(data);
      setIsSuccess(true);
    } catch (err) {
      setError('Bir hata oluştu. Lütfen tekrar deneyiniz.');
    } finally {
      setIsPending(false);
    }
  };

  const resetForm = () => {
    setIsSuccess(false);
    setError(null);
  };

  return {
    submitInquiry,
    isPending,
    isSuccess,
    error,
    resetForm,
  };
}
